import React, { useState, useEffect } from "react";
import {
  setStartDate,
  setEndDate,
  runQueryPagoda,
} from "../../../redux/action";
import { RootState } from "../../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import _ from "lodash";
import { PagodaProductData } from "../events.config";
import CommonTable from "../../../components/Table/CommonTable";
import axios from "axios";
import { downloadCSV } from "../../../screens/kayJwellers/helper";
import { Button, Grid, Typography } from "@mui/material";
import useClasses from "../../../common/UseClasses";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";

type PropsFromRedux = ConnectedProps<typeof connector>;
type ProductTabProps = PropsFromRedux & {};

const useStyles = () => ({
  container: {
    height: 440,
  },

  csvButton: {
    backgroundColor: "rgba(107,147,57,1)",
    height: 30,
    width: 80,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    color: "white",
    textDecorationLine: "none",
    marginBottom: 5,
    fontSize: 12,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
const ProductTab: React.FC<ProductTabProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
  runQueryPagoda,
  ...rest
}) => {
  // const classes = useStyles();
  const classes: any = useClasses(useStyles);

  const [eventsData, setEventsData] = useState<any>({});
  const [totalCount, setTotalCount] = useState<{ [key: string]: number }>({});

  const handleFromDateChange = (date: any | null) => {
    setStartDate(date.$d);
  };
  const handleToDateChange = (date: any | null) => {
    setEndDate(date.$d);
  };

  const getSkuData = (productSKU: any, requestheader: any) => {
    return new Promise(async (resolve, reject) => {
      axios
        .get(
          `https://api.virtualvisions.io/pagoda/v2/products/${productSKU}/data`,
          {
            headers: requestheader,
          }
        )
        .then((result) => {
          if (result.status === 200) {
            resolve(result.data);
          } else {
            reject(undefined);
          }
        })
        .catch((error) => {
          console.log("error ", error.response);
          reject(error);
        });
    });
  };

  const getProductData = async () => {
    let categorydata: any = {};

    let count: { [key: string]: number } = {};

    const startDate = moment(startDateObj).format("YYYYMMDD");
    const endDate = moment(endDateObj).format("YYYYMMDD");

    for (const product of PagodaProductData) {
      /* loop over each table configuration defined into events.config */

      count[product.label] = 0;

      let tableData: any = {
        tableHeader: [],
        tableRow: [],
      };

      let query = `${product.query} AND event_date >= '${startDate}' AND  event_date <= '${endDate}' ${product.appendquery}`; /* dynamically loads query from configuration file and forms query */

      const result: any = await runQueryPagoda(
        { query },
        false
      ); /*function call to execute query and retrieve data */

      let arr: any = [];

      result.forEach(async (resultdata: any, resultindex: number) => {
        /* loop over each object from response received from query */

        const obj: any = {};

        let product_sku = resultdata["product_sku"];

        product.headers.forEach((keyelement: any, index: number) => {
          /* map rows according to configuration defined in headers of configuration file */
          const headerkey = keyelement.key;
          obj[headerkey] = resultdata[headerkey];

          if (headerkey === "value")
            count[product.label] +=
              resultdata[
                headerkey
              ]; /* add each event count into total count of each table */
        });

        if (product.fetchapi && product_sku) {
          const productdata: any = await getSkuData(
            product_sku,
            product.requestheaders
          );
          productdata &&
            productdata.product &&
            product.customData.forEach((customkey: any) => {
              if (productdata.product[customkey])
                obj[customkey] = productdata.product[customkey];
            });

          if (
            productdata &&
            productdata.product &&
            productdata.product.price &&
            obj.value
          )
            obj.pricevalue = (productdata.product.price * obj.value).toFixed(2);
        }
        tableData.tableRow.push(obj); /* add row into  data array */
        arr.push(obj);
      });

      tableData.tableHeader.push(...product.headers);
      categorydata[product.label] = tableData; /* map table dynamically */
    }
    // console.log(categorydata)

    setEventsData(
      categorydata
    ); /* update state variable with data for each table */
    setTotalCount(
      count
    ); /* update total count for each table of state variable */
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          flex: 1,
          padding: 16,
          alignItems: "center",
          marginBottom: 20,
        }}
      >
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="From Date"
format="MM/DD/YYYY"
value={dayjs(startDateObj)}
sx={{marginRight:'10px'}}
onChange={handleFromDateChange}
/>
<DatePicker
label="To Date"
format="MM/DD/YYYY"
value={dayjs(endDateObj)}
sx={{marginRight:'10px'}}
onChange={handleToDateChange}
/>
    </LocalizationProvider>

        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="From Date"
            format="MM/dd/yyyy"
            value={startDateObj}
            onChange={handleFromDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            autoOk={true}
          />

          <KeyboardDatePicker
            style={{ marginLeft: 16 }}
            margin="normal"
            id="date-picker-dialog"
            label="To Date"
            format="MM/dd/yyyy"
            value={endDateObj}
            onChange={handleToDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            autoOk={true}
          />
        </MuiPickersUtilsProvider> */}

        <Button
          variant="contained"
          color="secondary"
          style={{
            width: 150,
            height:40,
            marginLeft: 20,
          }}
          onClick={() => getProductData()}
        >
          Apply
        </Button>
      </div>
      <Grid container spacing={4}>
        {eventsData
          ? Object.keys(eventsData)?.map((row: string, i: number) => {
              let tabledata = eventsData[row];
              // console.log(tabledata)
              return (
                <Grid item md={12} xs={6} lg={6} key={i}>
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: 1 }}>
                      <Typography style={{ fontSize: 14, fontWeight: 800 }} color="primary">
                        {`${row}`} <br />{" "}
                        {`(Total Count : ${totalCount[row]}) `}
                      </Typography>
                    </div>
                    <div style={{ justifyContent: "flex-end" }}>
                      <Button
                        variant="contained"
                        color="primary"
                          sx={{
                          height:40,
                          width:200,
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom:3
                          }}
                        onClick={() =>
                          {
                            tabledata.tableRow.length>0 &&
                            downloadCSV(
                              tabledata.tableRow,
                              row,
                              tabledata.tableHeader
                            )
                          }
                        }
                      >
                        {" "}
                        Download CSV
                      </Button>
                    </div>
                  </div>
                  {eventsData[row] ? (
                    <CommonTable tableData={eventsData[row]} />
                  ) : null}
                </Grid>
              );
            })
          : null}
      </Grid>
    </div>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
});

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
  runQueryPagoda,
});

export default connector(ProductTab);
